<template>
  <Link :href="'/'">
    <img
      class="w-48 h-auto center mx-auto"
      src="/photo/logo/small-logo.svg"
    />
  </Link>
</template>
